var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Support") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.586 0 0 3.584 0 8c0 4.415 3.586 8 8 8 4.416 0 8-3.585 8-8 0-1.92-.677-3.681-1.805-5.06A7.988 7.988 0 008 0zM8 2c1.874 0 3.546.86 4.648 2.205A6.002 6.002 0 018 14C4.69 14 2 11.311 2 8A6.004 6.004 0 018 2z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.007 11.094h1.997v1.935H7.007v-1.935zM4.563 6.27c.052-1.272.497-2.173 1.332-2.705.526-.34 1.174-.51 1.943-.51 1.01 0 1.848.24 2.514.725.668.481 1.002 1.196 1.002 2.143 0 .58-.145 1.07-.436 1.467-.168.24-.495.55-.977.923l-.476.369c-.259.2-.431.435-.515.704-.055.169-.083.432-.089.789H7.053c.028-.755.098-1.274.215-1.563.116-.29.415-.62.897-.996l.49-.38c.16-.121.29-.254.389-.396.178-.245.267-.516.267-.81 0-.34-.099-.65-.297-.928-.199-.279-.562-.42-1.09-.42-.518 0-.885.173-1.102.516a1.989 1.989 0 00-.325 1.072H4.563z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.ea9097998cb6b4525d55ba1644b55659.svg";
export { ForwardRef as ReactComponent };